import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CancelleriaTelematicaComponent } from './pages/cancelleria-telematica/cancelleria-telematica.component';
import { CancelleriaTelematicaGuard } from './guards/cancelleria-telematica.guard';
import { UrlSettingsCore } from '../core/configuration/url-settings-core';
import { ConsultazioneAnonimaComponent } from './pages/consultazione-anonima/consultazione-anonima.component';
import { ConsultazioneComponent } from './pages/consultazione/consultazione.component';
import { GestioneDelegheComponent } from './pages/gestione-deleghe/gestione-deleghe/gestione-deleghe.component';
import { GestionePagamentiComponent } from './pages/gestione-pagamenti/gestione-pagamenti.component';

const routes: Routes = [
  {
    path: "",
    component: CancelleriaTelematicaComponent,
    data:{title: "Cancelleria telematica"},
    canActivate: [CancelleriaTelematicaGuard],
    canActivateChild: [CancelleriaTelematicaGuard],
    children: []
  },
  {
    path: UrlSettingsCore.URL_CONSULTAZIONE_ANONIMA,
    component: ConsultazioneAnonimaComponent,
    canActivate: [CancelleriaTelematicaGuard],
    canActivateChild: [CancelleriaTelematicaGuard],
    children: []
  },
  {
    path: UrlSettingsCore.URL_CONSULTAZIONE,
    data:{title: "Consultazione"},
    component: ConsultazioneComponent,
    canActivate: [CancelleriaTelematicaGuard],
    canActivateChild: [CancelleriaTelematicaGuard],
    children: []
  },
  {
    path: UrlSettingsCore.URL_GESTIONE_DELEGHE_PDA,
    data:{title: "Gestione deleghe PDA"},
    component: GestioneDelegheComponent,
    canActivate: [CancelleriaTelematicaGuard],
    canActivateChild: [CancelleriaTelematicaGuard],
    children: []
  },
  {
    path: UrlSettingsCore.URL_GESTIONE_PAGAMENTI_PDA,
    data:{title: "Gestione pagamenti PDA"},
    component: GestionePagamentiComponent,
    canActivate: [CancelleriaTelematicaGuard],
    canActivateChild: [CancelleriaTelematicaGuard],
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdaRoutingModule { }
